import { useMemo } from "react"

function getCssVar(varName, fallback) {
    if (typeof window === "undefined") return fallback
    const value = getComputedStyle(document.documentElement).getPropertyValue(varName).trim()
    return value || fallback
}

export function useChartColors() {
    const primaryColor = useMemo(() => getCssVar("--bs-primary", "#0f766e"), [])
    const secondaryColor = useMemo(() => getCssVar("--bs-gray-300", "#e4e6ef"), [])
    return { primaryColor, secondaryColor }
}
